import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import "../../Register Styles/animate.min.css";
import "../../Register Styles/aos.min.css";
import "../../Register Styles/bootstrap.min.css";
import "../../Register Styles/cursor.min.css";
import "../../Register Styles/custom.min.css";
import "../../Register Styles/magnific-popup.min.css";
import "../../Register Styles/odometer.min.css";
import "../../Register Styles/style.css";
import "../../Register Styles/swiper-bundle.min.css";

// Import images
import logo from "../../assets/images/site_logo/logo.webp";
import shapeNet from "../../assets/images/shapes/shape_net_ico_hero_section_bg.svg";
import shapeBottom from "../../assets/images/shapes/shape_ico_hero_section_bottom.svg";
import shapeGlobe from "../../assets/images/shapes/shape_globe.webp";
import shapeCoin from "../../assets/images/shapes/shape_coin.webp";
import shapeCountdownBg from "../../assets/images/shapes/shape_bg_ico_countdown.svg";
import shapePoligon from "../../assets/images/shapes/shape_poligon.svg";
import shapeSectionDivider1 from "../../assets/images/shapes/shape_section_divider_1.svg";
import shapeSectionDivider2 from "../../assets/images/shapes/shape_section_divider_2.svg";
import shapeCircle1 from "../../assets/images/shapes/shape_circle_1.webp";
import aboutImage from "../../assets/images/about/about_image.svg";
import iconCoinsImage from "../../assets/images/shapes/ico_coins_image.svg";

// Import partner logos
import partnerLogo1 from "../../assets/images/partners/partner_logo_1.svg";
import partnerLogo2 from "../../assets/images/partners/partner_logo_2.svg";
import partnerLogo3 from "../../assets/images/partners/partner_logo_3.svg";
import partnerLogo4 from "../../assets/images/partners/partner_logo_4.svg";
import partnerLogo5 from "../../assets/images/partners/partner_logo_5.svg";
import partnerLogo6 from "../../assets/images/partners/partner_logo_6.svg";
import partnerLogo7 from "../../assets/images/partners/partner_logo_7.svg";

// Import icons
import iconManQuestion from "../../assets/icons/icon_man_question.svg";
import iconBulb from "../../assets/icons/icon_bulb.svg";
import iconCheck from "../../assets/icons/icon_check.svg";
import iconDollar2 from "../../assets/icons/icon_dollar_2.svg";
import iconBankBuilding from "../../assets/icons/icon_bank_building.svg";
import iconScan from "../../assets/icons/icon_scan.svg";
import iconPinpoint from "../../assets/images/services/icon_pinpoint.png";
import iconTokenSupply from "../../assets/icons/icon_token_supply.svg";
import iconTokenNetwork from "../../assets/icons/icon_token_network.svg";
import iconEstimatedLaunchPrice from "../../assets/icons/icon_estimated_launch_price.svg";
import iconExpectedRipplePrice from "../../assets/icons/icon_expected_ripple_price.svg";

// Import team avatars - Using placeholder for missing .webp files
import avatar1 from "../../assets/images/avatars/avatar_1.webp";
// Create placeholders for missing avatar files
const placeholderAvatar = avatar1; // Use avatar1 as placeholder

const Home = () => {
  useEffect(() => {
    // Initialize AOS animations
    if (window.AOS) {
      window.AOS.init({
        duration: 1000,
        once: true,
      });
    }

    // Initialize Swiper for partner carousel
    if (window.Swiper) {
      new window.Swiper(".partner_logo_carousel", {
        slidesPerView: 6,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 6,
          },
        },
      });
    }

    // Initialize odometer counters
    const initializeOdometer = () => {
      const odometers = document.querySelectorAll('.odometer');
      odometers.forEach(odometer => {
        const count = odometer.getAttribute('data-count') || 0;
        odometer.textContent = count;
      });
    };

    setTimeout(initializeOdometer, 1000);

    // Countdown timer
    const initializeCountdown = () => {
      const countdownElement = document.querySelector('.countdown_timer_block');
      if (countdownElement) {
        const targetDate = new Date('2026-03-24').getTime();
        
        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = targetDate - now;
          
          if (distance < 0) {
            countdownElement.innerHTML = '<span>ICO Ended</span>';
            return;
          }
          
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          countdownElement.innerHTML = `
            <li>
              <span class="odometer" data-count="${days}">${days}</span>
              <span class="text">Days</span>
            </li>
            <li>
              <span class="odometer" data-count="${hours}">${hours}</span>
              <span class="text">Hours</span>
            </li>
            <li>
              <span class="odometer" data-count="${minutes}">${minutes}</span>
              <span class="text">Minutes</span>
            </li>
            <li>
              <span class="odometer" data-count="${seconds}">${seconds}</span>
              <span class="text">Seconds</span>
            </li>
          `;
        };
        
        updateCountdown();
        setInterval(updateCountdown, 1000);
      }
    };

    setTimeout(initializeCountdown, 1500);

    return () => {
      // Cleanup if needed
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="page_wrapper index_ico">
      {/* Back To Top - Start */}
      <div className="backtotop">
        <a href="#" className="scroll" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <i className="fa-solid fa-arrow-up" />
        </a>
      </div>
      {/* Back To Top - End */}

    

      {/* Site Header - Start */}
      <header className="site_header">
        <div className="nav_wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-4 d-flex align-items-center">
                <div className="site_logo">
                  <Link className="site_link" to="/">
                    <img loading="lazy" src={logo} alt="Willow Trades Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-1">
                <nav className="main_menu navbar-box navbar-expand-lg">
                  <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
                    <ul className="main_menu_list unordered_list text-uppercase">
                      <li className="active">
                        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Home</a>
                      </li>
                      <li>
                        <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_about_section'); }}>About Us</a>
                      </li>
                      <li>
                        <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Services</a>
                      </li>
                      <li>
                        <a href="#metamask" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Metamask</a>
                      </li>
                      <li>
                        <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Contact Us</a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="col-lg-3 col-7">
                <ul className="btns_group unordered_list p-0 justify-content-end">
                  <li className="d-lg-none">
                    <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                      <i className="fa fa-bars" />
                    </button>
                  </li>
                  <li>
                    <Link className="ico_btn_outline" to="/signin">
                      <span className="btn_icon">
                        <i className="fa-solid fa-user" />
                      </span>
                      <span className="btn_label">Login</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Site Header - End */}

      {/* Main Body - Start */}
      <main className="page_content">
        {/* Hero Section - Start */}
        <section className="ico_hero_section section_decoration text-center" style={{ backgroundImage: `url(${shapeNet})` }}>
          <div className="container">
            <h1 className="hero_title" data-aos="fade-up" data-aos-duration={800}>
              Willow Trades<br /><span>A Premium Crypto Assets Management Company.</span>
            </h1>
            <ul className="btns_group unordered_list justify-content-center p-0" data-aos="fade-up" data-aos-duration={800} data-aos-delay={100}>
              <li>
                <a className="ico_creative_btn" href="#!">
                  <span className="btn_wrapper">
                    <span className="btn_icon_left">
                      <small className="dot_top" />
                      <small className="dot_bottom" />
                      <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                        <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                        <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                      </svg>
                    </span>
                    <span className="btn_label">Purchase a Token</span>
                    <span className="btn_icon_right">
                      <small className="dot_top" />
                      <small className="dot_bottom" />
                      <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                        <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                        <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                      </svg>
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a className="ico_creative_btn" href="#!">
                  <span className="btn_wrapper">
                    <span className="btn_icon_left">
                      <small className="dot_top" />
                      <small className="dot_bottom" />
                      <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                        <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                        <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                      </svg>
                    </span>
                    <span className="btn_label">Read Documents</span>
                    <span className="btn_icon_right">
                      <small className="dot_top" />
                      <small className="dot_bottom" />
                      <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                        <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                        <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                      </svg>
                    </span>
                  </span>
                </a>
              </li>
            </ul>
            <div data-aos="fade-up" data-aos-duration={600} data-aos-delay={200}>
              <div className="ico_countdown_progress_box">
                <div className="ico_heading_block text-center mb-0">
                  <h2 className="highlight_title mb-0">
                    Start buy coinpay now!
                  </h2>
                </div>
                <ul className="countdown_timer_block unordered_list justify-content-center" data-countdown="2026/3/24" style={{ backgroundImage: `url(${shapeCountdownBg})` }}>
                  {/* Countdown will be populated by JS */}
                </ul>
                <div className="ico_progress">
                  <ul className="progress_range_step unordered_list justify-content-between">
                    <li>Soft Cap: $1.75m</li>
                    <li>Hard Cap: $4.75m</li>
                    <li>Bonus</li>
                  </ul>
                  <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <ul className="progress_value unordered_list justify-content-between">
                    <li>Minimum Purchase: 200 ICOX</li>
                    <li>Raised so far: $1,830,985</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="shape_bottom">
            <img src={shapeBottom} alt="Bottom Line Shape" />
          </div>
          <div className="decoration_item shape_globe">
            <img src={shapeGlobe} alt="Shape Globe" />
          </div>
          <div className="decoration_item shape_coin">
            <img src={shapeCoin} alt="Shape Coin" />
          </div>
        </section>
        {/* Hero Section - End */}

        {/* Partner Section - Start */}
        <section className="partner_section">
          <div className="container">
            <div className="ico_heading_block text-center">
              <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration={600}>
                Our top Partner
              </h2>
            </div>
            <div className="partner_logo_carousel z-2 position-relative" data-aos="fade-up" data-aos-duration={600} data-aos-delay={200}>
              <div className="swiper-wrapper">
                {[1, 2, 3, 4, 5, 6, 7, 1, 2, 3, 4, 5, 6, 7, 2].map((num, index) => (
                  <div className="swiper-slide" key={index}>
                    <div className="ico_partner_logo">
                      <a className="logo_wrap" href="#!">
                        <img 
                          src={
                            num === 1 ? partnerLogo1 :
                            num === 2 ? partnerLogo2 :
                            num === 3 ? partnerLogo3 :
                            num === 4 ? partnerLogo4 :
                            num === 5 ? partnerLogo5 :
                            num === 6 ? partnerLogo6 :
                            partnerLogo7
                          } 
                          alt={`Partner Logo ${num}`} 
                        />
                        <span className="dot_1" />
                        <span className="dot_2" />
                        <span className="dot_3" />
                        <span className="dot_4" />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* Partner Section - End */}

        {/* About Section - Start */}
        <section id="id_ico_about_section" className="ico_about_section section_space pb-0 section_decoration">
          <div className="container">
            <div className="row justify-content-lg-between">
              <div className="col-lg-6">
                <div className="ico_heading_block" data-aos="fade-up" data-aos-duration={600}>
                  <h2 className="heading_text mb-3">Introducing Willow Trades</h2>
                  <p className="info_description mb-3">
                    Coinpay's market opportunity stems from its growing adoption as a digital asset and payment method. As interest from investors, businesses, and institutions increases, It's finance and retail is expanding, boosting its value and utility. Our team has created blockchain solutions for over 400 companies, and we are still growing. From less paperwork and fewer disputes, to happier customers and entirely new business methods, a shared record of truth is invaluable.
                  </p>
                  <p className="info_description mb-3">
                    Coinpay's market opportunity stems from its growing adoption as a digital asset and payment method. As interest from investors, businesses, and institutions increases, It's finance and retail is expanding, boosting its value and utility. Our team has created blockchain solutions for over 400 companies, and we are still growing. From less paperwork and fewer disputes, to happier customers and entirely new business methods, a shared record of truth is invaluable.
                  </p>
                  <p className="info_description mb-0">
                    Coinpay's market opportunity stems from its growing adoption as a digital asset and payment method. As interest from investors, businesses, and institutions increases, It's finance and retail is expanding, boosting its value and utility.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 d-lg-flex flex-lg-column-reverse">
                <div className="ico_about_image text-center">
                  <div className="ripple_shape mb-lg-5">
                    <svg viewBox="0 0 501 455" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M500.5 227.5C500.5 352.824 388.618 454.5 250.5 454.5C112.382 454.5 0.5 352.824 0.5 227.5C0.5 102.176 112.382 0.5 250.5 0.5C388.618 0.5 500.5 102.176 500.5 227.5Z" stroke="url(#sro_paint0)" />
                      <path d="M463.5 247.5C463.5 361.81 368.15 454.5 250.5 454.5C132.85 454.5 37.5 361.81 37.5 247.5C37.5 133.19 132.85 40.5 250.5 40.5C368.15 40.5 463.5 133.19 463.5 247.5Z" stroke="url(#sro_paint1)" />
                      <path d="M425.5 268C425.5 371.031 347.12 454.5 250.5 454.5C153.88 454.5 75.5 371.031 75.5 268C75.5 164.969 153.88 81.5 250.5 81.5C347.12 81.5 425.5 164.969 425.5 268Z" stroke="url(#sro_paint2)" />
                      <path d="M379.5 268C379.5 343.97 321.715 405.5 250.5 405.5C179.285 405.5 121.5 343.97 121.5 268C121.5 192.03 179.285 130.5 250.5 130.5C321.715 130.5 379.5 192.03 379.5 268Z" stroke="url(#sro_paint3)" />
                      <defs>
                        <linearGradient id="sro_paint0" x1="250.5" y1={0} x2="250.5" y2={455} gradientUnits="userSpaceOnUse">
                          <stop offset={0} stopColor="#2A246D" />
                          <stop offset={1} stopColor="#2A246D" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="sro_paint1" x1="250.5" y1={40} x2="250.5" y2={455} gradientUnits="userSpaceOnUse">
                          <stop offset={0} stopColor="#2A246D" />
                          <stop offset={1} stopColor="#2A246D" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="sro_paint2" x1="250.5" y1={81} x2="250.5" y2={455} gradientUnits="userSpaceOnUse">
                          <stop offset={0} stopColor="#2A246D" />
                          <stop offset={1} stopColor="#2A246D" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="sro_paint3" x1="250.5" y1={130} x2="250.5" y2={406} gradientUnits="userSpaceOnUse">
                          <stop offset={0} stopColor="#2A246D" />
                          <stop offset={1} stopColor="#2A246D" stopOpacity={0} />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="coin_image">
                    <img src={aboutImage} alt="About Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="decoration_item shape_shadow_1">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
          <div className="decoration_item shape_shadow_2">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
        </section>
        {/* About Section - End */}

        {/* Problem and Solution Section - Start */}
        <section className="problem_solution_section section_space">
          <div className="container">
            <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration={600}>
              <h2 className="heading_text mb-0">
                Willow Trades Problem & Solution
              </h2>
            </div>
            <div className="ico_problem_solution_table" data-aos="fade-up" data-aos-duration={600} data-aos-delay={100}>
              <div className="column_wrapper">
                <div className="column_problem">
                  <h3 className="heading_text">
                    <span className="icon">
                      <img src={iconManQuestion} alt="Icon Man With Question" />
                    </span>
                    <span className="text">ICO Problem</span>
                  </h3>
                  <ul className="iconlist_block unordered_list_block">
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Identify the Issue.
                        <small className="iconlist_info">
                          We ensure transparency with clear updates.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Impact of the Problem.
                        <small className="iconlist_info">
                          The Problem in an ICO attracts investor confidence.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Reduced Investment.
                        <small className="iconlist_info">
                          Less trust means fewer investments.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Scaling and Absolete Tool.
                        <small className="iconlist_info">
                          Limited scalability hinders growth and expansion.
                        </small>
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="column_solution">
                  <h3 className="heading_text">
                    <span className="icon">
                      <img src={iconBulb} alt="Icon Bulb" />
                    </span>
                    <span className="text">ICO Solution</span>
                  </h3>
                  <ul className="iconlist_block unordered_list_block">
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Introduce the Project and Token.
                        <small className="iconlist_info">
                          Our ICO Vision building a Decentralized Ad Network.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Key Features or Innovations.
                        <small className="iconlist_info">
                          Advanced tech, top security, and smooth scalability.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Benefits to Users and Investors.
                        <small className="iconlist_info">
                          Transparency, security, and growth potential.
                        </small>
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_icon">
                        <img src={iconCheck} alt="Icon Check" />
                      </span>
                      <span className="iconlist_label">
                        Global Single-Platform.
                        <small className="iconlist_info">
                          Seamless access and transactions worldwide.
                        </small>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Problem and Solution Section - End */}

        {/* Service Section - Start */}
        <section id="id_ico_service_section" className="ico_service_section section_space pb-0 section_decoration section_shadow_top">
          <div className="decoration_item shape_divider_1">
            <img src={shapeSectionDivider1} alt="Shape Divider" />
          </div>
          <div className="container">
            <div className="ico_heading_block text-center mt-lg-4" data-aos="fade-up" data-aos-duration={600}>
              <h2 className="heading_text mb-0">
                Why You Choose Willow Trades?
              </h2>
            </div>
            <div className="row m-lg-0 justify-content-center">
              <div className="col-lg-3 p-lg-0" data-aos="fade-up" data-aos-duration={600} data-aos-delay={200}>
                <div className="ico_iconbox_block">
                  <div className="iconbox_icon">
                    <img src={iconDollar2} alt="Icon Dollar" />
                  </div>
                  <div className="iconbox_info">
                    <h3 className="iconbox_title">
                      Universal ATM
                    </h3>
                    <p className="iconbox_description mb-0">
                      ATM for stable currency unicast any other currencies.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 p-lg-0" data-aos="fade-up" data-aos-duration={600} data-aos-delay={300}>
                <div className="ico_iconbox_block">
                  <div className="iconbox_icon">
                    <img src={iconBankBuilding} alt="Icon Bank Building" />
                  </div>
                  <div className="iconbox_info">
                    <h3 className="iconbox_title">
                      Smart Banking Branch
                    </h3>
                    <p className="iconbox_description mb-0">
                      kyc handles lender negotiation or insurance procedures.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 p-lg-0" data-aos="fade-up" data-aos-duration={600} data-aos-delay={400}>
                <div className="ico_iconbox_block">
                  <div className="iconbox_icon">
                    <img src={iconScan} alt="Icon Scan" />
                  </div>
                  <div className="iconbox_info">
                    <h3 className="iconbox_title">
                      Automation
                    </h3>
                    <p className="iconbox_description mb-0">
                      Payment of invoices, create, deposited or integration for betting offices.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 p-lg-0" data-aos="fade-up" data-aos-duration={600} data-aos-delay={500}>
                <div className="ico_iconbox_block">
                  <div className="iconbox_icon">
                    <img src={iconPinpoint} alt="Icon Pinpoint" />
                  </div>
                  <div className="iconbox_info">
                    <h3 className="iconbox_title">
                      Decentralization
                    </h3>
                    <p className="iconbox_description mb-0">
                      All transactions are in a blockchain, each machine is a network builder.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="decoration_item shape_shadow_1">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
          <div className="decoration_item shape_shadow_2">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
        </section>
        {/* Service Section - End */}

        {/* Tokenomics Section - Start */}
        <section id="id_ico_tokenomics_section" className="ico_tokenomics_section section_space pb-0">
          <div className="container">
            <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration={600}>
              <h2 className="heading_text mb-0">
                Willow Trades Tokenomics
              </h2>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-4 position-relative z-1">
                <ul className="tokenomics_block unordered_list_block">
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={100}>
                    <div className="percent">15%</div>
                    <div className="info">
                      <h4 className="heading_text">Presale</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={200}>
                    <div className="percent">22%</div>
                    <div className="info">
                      <h4 className="heading_text">CEX & DEX Liquidity</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={300}>
                    <div className="percent">13%</div>
                    <div className="info">
                      <h4 className="heading_text">Team</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={400}>
                    <div className="percent">12%</div>
                    <div className="info">
                      <h4 className="heading_text">Community Incentives</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={500}>
                    <div className="percent">10%</div>
                    <div className="info">
                      <h4 className="heading_text">Marketing</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={600}>
                    <div className="percent">28%</div>
                    <div className="info">
                      <h4 className="heading_text">Treasury and Ecosystem Growth</h4>
                      <div className="value">
                        [<span className="odometer" data-count={1200000000}>0</span><span>$</span>]
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4">
                <div className="icon_coins_image">
                  <img src={iconCoinsImage} alt="ICO Coin Image" />
                </div>
              </div>
              <div className="col-lg-4 position-relative z-1">
                <ul className="ico_features_group unordered_list_block">
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={100}>
                    <div className="ico_iconbox_icon_left">
                      <div className="iconbox_icon">
                        <img src={iconTokenSupply} alt="Icon Token Supply" />
                      </div>
                      <div className="iconbox_info">
                        <h3 className="iconbox_title">Total Token Supply</h3>
                        <p className="iconbox_description mb-0">8.000.000.000 $</p>
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={200}>
                    <div className="ico_iconbox_icon_left">
                      <div className="iconbox_icon">
                        <img src={iconTokenNetwork} alt="Icon Token Network" />
                      </div>
                      <div className="iconbox_info">
                        <h3 className="iconbox_title">Token Network</h3>
                        <p className="iconbox_description mb-0">ERC-20$</p>
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={300}>
                    <div className="ico_iconbox_icon_left">
                      <div className="iconbox_icon">
                        <img src={iconEstimatedLaunchPrice} alt="Icon Estimated Launch Price" />
                      </div>
                      <div className="iconbox_info">
                        <h3 className="iconbox_title">Estimated Launch price</h3>
                        <p className="iconbox_description mb-0">0.20$</p>
                      </div>
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration={600} data-aos-delay={400}>
                    <div className="ico_iconbox_icon_left">
                      <div className="iconbox_icon">
                        <img src={iconExpectedRipplePrice} alt="Icon Expected Ripple Price" />
                      </div>
                      <div className="iconbox_info">
                        <h3 className="iconbox_title">Expected Ripple price</h3>
                        <p className="iconbox_description mb-0">0.80 $</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="btns_group pb-0 justify-content-center" data-aos="fade-up" data-aos-duration={600}>
              <a className="ico_creative_btn" href="#!">
                <span className="btn_wrapper">
                  <span className="btn_icon_left">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                      <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                      <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                    </svg>
                  </span>
                  <span className="btn_label">Purchase a Token</span>
                  <span className="btn_icon_right">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                      <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                      <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                    </svg>
                  </span>
                </span>
              </a>
            </div>
          </div>
        </section>
        {/* Tokenomics Section - End */}

        {/* ICO Roadmap Section - Start */}
        <section id="id_ico_roadmap_section" className="ico_roadmap_section section_space mt-lg-5 section_decoration">
          <div className="container">
            <div className="ico_heading_block text-center mt-lg-5 pt-lg-5" data-aos="fade-up" data-aos-duration={600}>
              <h2 className="heading_text mb-0">
                Roadmap
              </h2>
            </div>
            <div className="ico_roadmap_flexbox" data-aos="fade-up" data-aos-duration={600} data-aos-delay={100}>
              {[
                {
                  badge: "Q1 - 2024",
                  title: "Concept & Planning",
                  items: [
                    "Conduct in-depth analysis to identify market opportunities and challenges.",
                    "Develop a clear and innovative concept tailored to industry needs.",
                    "Prepare a comprehensive document detailing the project's vision, goals, and tokenomics."
                  ]
                },
                {
                  badge: "Q2 - 2024",
                  title: "Community Building",
                  items: [
                    "Connect with potential investors and users to create awareness.",
                    "Leverage social platforms to grow the community and keep them informed.",
                    "Offer rewards and bonuses to early supporters to build trust.",
                    "Host AMAs and sessions to engage."
                  ]
                },
                {
                  badge: "Q3 - Q2 2025",
                  title: "ICO Launch",
                  items: [
                    "Strong community interest and early investments that build momentum.",
                    "Achieving target funding goals during the ICO period, project viability.",
                    "Successful listing on major exchanges, increasing liquidity and user access.",
                    "Key feature milestones achieved."
                  ]
                },
                {
                  badge: "Q4 - 2025",
                  title: "Token Distribution",
                  items: [
                    "Tokens for public sale to investors.",
                    "Allocate tokens for the team.",
                    "Set aside tokens for future needs.",
                    "Tokens will drive community and marketing efforts.",
                    "Reward participants for promotion."
                  ]
                }
              ].map((stage, index) => (
                <div className="roadmap_block" key={index}>
                  <div className="badge">{stage.badge}</div>
                  <h3 className="heading_text">{stage.title}</h3>
                  <ul className="iconlist_block unordered_list_block">
                    {stage.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <span className="iconlist_icon">
                          <i className="fa-solid fa-circle" />
                        </span>
                        <span className="iconlist_label">{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="hover_shape">
                    <img src={shapeCircle1} alt="Shape Circle" />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="decoration_item shape_divider_1">
            <img src={shapeSectionDivider2} alt="Shape Divider" />
          </div>
        </section>
        {/* ICO Roadmap Section - End */}

        {/* Team Section - Start */}
        <section id="id_ico_team_section" className="ico_team_section section_decoration section_shadow_top section_space">
          <div className="decoration_item shape_divider_1">
            <img src={shapeSectionDivider1} alt="Shape Divider" />
          </div>
          <div className="container">
            <div className="ico_heading_block mt-lg-5 pt-lg-5 text-center" data-aos="fade-up" data-aos-duration={800}>
              <h2 className="heading_text mb-0">
                Active Team & Advisors
              </h2>
            </div>
            <div className="tab_block" data-aos="fade-up" data-aos-duration={800} data-aos-delay={100}>
              <div className="tab-content">
                <div className="tab-pane fade show active" role="tabpanel" id="tab_advisory_team">
                  <div className="row justify-content-center">
                    {[
                      { name: "Levi Harrison", role: "Compliance Officer", description: "Compliance Officer ensuring regulatory adherence and risk management." },
                      { name: "Luna Seraphine", role: "Financial Officer", description: "Financial Officer focused on profitability and resource management." },
                      { name: "Elias Maverick", role: "Founder & CEO", description: "A hands on founder who loves building scaling businesses with clients." },
                      { name: "Atticus Graham", role: "Technical Support", description: "Passionate in seeking solutions for your problems." },
                      { name: "Amara Noelle", role: "CTO Manager", description: "CTO Manager driving tech innovation and overseeing development strategies." },
                      { name: "Ethan Mitchell", role: "Blockchain Developer", description: "Blockchain Developer building secure and scalable decentralized solutions." },
                      { name: "Aurora Selene", role: "Legal Advisor", description: "Legal Advisor providing expert guidance on legal matters and risk management." },
                      { name: "Orion Maxwell", role: "Project Manager", description: "Committed to delivering successful projects consistently." }
                    ].map((member, index) => (
                      <div className="col-lg-3 col-md-6 col-sm-6" key={index}>
                        <div className="ico_team_block">
                          <div className="ico_team_block_inner">
                            <div className="front_side_content">
                              <div className="team_avatar" style={{ backgroundImage: `url(${shapeCircle1})` }}>
                                <div className="avatar_wrap">
                                  <img src={placeholderAvatar} alt={member.name} />
                                </div>
                              </div>
                              <h3 className="team_member_name">{member.name}</h3>
                              <span className="team_member_designation mb-0">{member.role}</span>
                            </div>
                            <div className="back_side_content">
                              <p className="team_member_description">{member.description}</p>
                              <ul className="social_block unordered_list justify-content-center">
                                <li>
                                  <a href="#!">
                                    <i className="fa-brands fa-linkedin" />
                                  </a>
                                </li>
                              </ul>
                              <h4 className="team_member_name">{member.name}</h4>
                              <span className="team_member_designation mb-0">{member.role}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="decoration_item shape_divider_1">
            <img src={shapeSectionDivider2} alt="Shape Divider" />
          </div>
          <div className="decoration_item shape_shadow_1">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
          <div className="decoration_item shape_shadow_2">
            <img src={shapePoligon} alt="Shape Color Shadow" />
          </div>
        </section>
        {/* Team Section - End */}

        {/* FAQ Section - Start */}
        <section className="faq_section section_space top">
          <div className="container">
            <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration={800}>
              <h2 className="heading_text mb-0">
                FAQ
              </h2>
            </div>
            <div className="tab_block" data-aos="fade-up" data-aos-duration={800} data-aos-delay={100}>
              <div className="d-flex justify-content-center">
                <ul className="nav unordered_list justify-content-md-center" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" data-bs-target="#tab_general_question" data-bs-toggle="tab" type="button" role="tab" aria-selected="true">General Question</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" data-bs-target="#tab_ico_questions" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">ICO Questions</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" data-bs-target="#tab_tokens_sales" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">Tokens Sales</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" data-bs-target="#tab_clients_releted" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">Clients Releted</button>
                  </li>
                </ul>
              </div>
              <div className="tab-content">
                {["tab_general_question", "tab_ico_questions", "tab_tokens_sales", "tab_clients_releted"].map((tabId, tabIndex) => (
                  <div className={`tab-pane fade ${tabIndex === 0 ? 'show active' : ''}`} role="tabpanel" id={tabId} key={tabId}>
                    <div className="ico_accordion" id={`accordion_${tabIndex + 1}`}>
                      {[1, 2, 3, 4, 5].map((itemIndex) => (
                        <div className="accordion-item" key={itemIndex}>
                          <div className={`icon_arrow ${itemIndex === 1 ? '' : 'collapsed'}`} role="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${(tabIndex * 5) + itemIndex}`} aria-expanded={itemIndex === 1 ? "true" : "false"}>
                            <svg viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                              <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                              <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                            </svg>
                          </div>
                          <div className={`accordion-button ${itemIndex === 1 ? '' : 'collapsed'}`} role="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${(tabIndex * 5) + itemIndex}`} aria-expanded={itemIndex === 1 ? "true" : "false"}>
                            {itemIndex === 1 && "01- What is CoinPay ICO?"}
                            {itemIndex === 2 && "02- How can I participate in the CoinPay ICO?"}
                            {itemIndex === 3 && "03- What are the benefits of investing in CoinPay ICO?"}
                            {itemIndex === 4 && "04- What is the total supply of CoinPay tokens?"}
                            {itemIndex === 5 && "05- Can I sell my tokens after the ICO?"}
                          </div>
                          <div id={`collapse_${(tabIndex * 5) + itemIndex}`} className={`accordion-collapse collapse ${itemIndex === 1 ? 'show' : ''}`} data-bs-parent={`#accordion_${tabIndex + 1}`}>
                            <div className="accordion-body">
                              <p>
                                You can participate in the CoinPay ICO, simply register on our platform, complete the KYC (Know Your Customer) process, and follow the instructions to purchase tokens during the ICO period, Once registered buy tokens with secure payments.
                              </p>
                              <ul className="iconlist_block unordered_list_block">
                                <li>
                                  <span className="iconlist_icon">
                                    <i className="fa-solid fa-circle" />
                                  </span>
                                  <span className="iconlist_label">
                                    Sign up and complete the KYC process.
                                  </span>
                                </li>
                                <li>
                                  <span className="iconlist_icon">
                                    <i className="fa-solid fa-circle" />
                                  </span>
                                  <span className="iconlist_label">
                                    Follow instructions to purchase tokens securely.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* FAQ Section - End */}
      </main>
      {/* Main Body - End */}

      {/* Site Footer - Start */}
      <footer className="ico_site_footer section_decoration section_shadow_top">
        <div className="decoration_item shape_top">
          <img src={shapeBottom} alt="Bottom Line Shape" />
        </div>
        <div className="container">
          <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
            <li><a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Home</a></li>
            <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_about_section'); }}>About Us</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Services</a></li>
            <li><a href="#metamask" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Metamask</a></li>
            <li><a href="#team" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_team_section'); }}>Team</a></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('id_ico_service_section'); }}>Contact Us</a></li>
          </ul>
          <div className="middle_area">
            <div className="column">
              <h3 className="footer_title text-uppercase">Join our social group</h3>
              <ul className="social_block style_2 unordered_list justify-content-center">
                <li>
                  <a href="#.">
                    <i className="fa-brands fa-facebook" />
                  </a>
                </li>
                <li>
                  <a href="#.">
                    <i className="fa-brands fa-instagram" />
                  </a>
                </li>
                <li>
                  <a href="#.">
                    <i className="fa-brands fa-github" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Subscribe to our newslatter</h3>
              <form className="ico_newsletter_form" onSubmit={(e) => e.preventDefault()}>
                <input type="email" name="email" placeholder="Enter your email" />
                <button className="submit_btn" type="submit">Submit</button>
              </form>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
              <a className="ico_btn_outline" href="#.">Purchase a Token</a>
            </div>
          </div>
          <div className="footer_bottom text-center">
            <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Trades. All rights reserved.</p>
          </div>
        </div>
      </footer>
      {/* Site Footer - End */}
    </div>
  );
};

export default Home;